import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;

  @media (screen-spanning: single-fold-vertical) {
    width: env(fold-left);
  }

  @media (horizontal-viewport-segments: 2) {
    width: env(viewport-segment-right 0 0);
  }
`;

export const ImageContainer = styled.div`
  overflow: hidden;
`;

const shouldForwardProp = () => true;

export const Image = styled('img').withConfig({ shouldForwardProp })`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const Text = styled.p`
  margin: 0 var(--gap);
  font-family: Butler, serif;
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  white-space: pre-wrap;
`;

export const SubText = styled.p`
  margin: 0 var(--gap);
  font-family: Butler, serif;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  white-space: pre-wrap;
`;
